import Loadable from "react-loadable";
import { EmptyComponent } from "../../components/common/EmptyComponent.js";
import { BrandUtils } from "../../utils/index.js";

export const loadLoyaltySection = (brandId, clientProvider) =>
  Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${brandId}/${clientProvider}/LoyaltySection.layout.js`
      ),
    loading: EmptyComponent
  });

export const preload = ({ clientProvider, brandId }) => {
  if (BrandUtils.isPokerClient())
    loadLoyaltySection(brandId, clientProvider)?.preload();
};
